<template>
  <div class="page">
    <div class="hd">
      <router-link class="backup iconfont iconpre" :to="backpath">
        返回列表
      </router-link>
      <span class="title-mag">{{ title }}</span>
      <span
        class="cale iconfont iconcalendar actable"
        @click.prevent="$emit('caleclick')"
        >過往期刊</span
      >
    </div>

    <slot></slot>
    <slot name="ft"></slot>
  </div>
</template>
<script>
import { getBackPath, MAGZ_BACK_PATH_KEY } from "@/libs/utils";
export default {
  props: ["title"],
  data() {
    const backpath = getBackPath(MAGZ_BACK_PATH_KEY) ?? "/";
    return { backpath };
  },
};
</script>

<style src="./_layout.css" />;
